module.exports = ".user-panel {\r\n  border-top: none!important;\r\n}"